import {initElements} from "../define/shared"

export default function initRestaurantCuPage() {
    initElements(".restaurantCuPage", page => {
        const buttons = {
            open: page.querySelector('.openModal'),
            close: page.querySelector('.closeModal')
        }
        const modal = page.querySelector('.restaurantCuPage-sidebar-modal')

        buttons.open.addEventListener('click', ()=>{
            modal.classList.add('is--open')
        })

        buttons.close.addEventListener('click', ()=>{
            modal.classList.remove('is--open')
        })
    })
}
